import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import DataTable from "react-data-table-component";
import Hdashboard from "../../../components/Hdashboard";
import JqueryLoad from "../../../JqueryLoad/JqueryLoad";
import { parentLearnerList } from "../../../api/apiHandler";
import customStyles from "../../../utils/dataTableStyles";
import moment from "moment";

export default function ParentLearnerList({ isLoader }) {
    const location = useLocation();
    const navigate = useNavigate();
    const stateParams = location.state || {};

    const [data, setData] = useState([]);
    const [paginationOption, setPaginationOption] = useState(10);
    const [paginationOptions, setPaginationOptions] = useState([]);

    useEffect(() => {
        if (!stateParams.user_id) {
            navigate(-1);
            return;
        }
        fetchLearners();
    }, []);

    const fetchLearners = () => {
        isLoader(true);
        parentLearnerList({ id: stateParams.user_id })
            .then((response) => {
                if (response.code === "1") {
                    const withCount = response.data.map((row, idx) => ({ ...row, count: idx + 1 }));
                    setData(withCount);
                    const opts = [];
                    for (let i = 10; i <= withCount.length; i += 10) opts.push(i);
                    if (withCount.length <= 100) opts.push(withCount.length);
                    setPaginationOptions(opts);
                } else {
                    setData([]);
                }
            })
            .catch(() => setData([]))
            .finally(() => isLoader(false));
    };

    const handleBack = () => navigate(-1);

    const handlePaginationChange = (rowsPerPage) => {
        setPaginationOption(rowsPerPage);
    };

    const columns = [
        {
            name: "Sr. No",
            selector: (row) => row.count,
            sortable: false,
            width: "100px",
        },
        {
            name: "Profile",
            selector: (row) => row.learner_profile_img,
            sortable: false,
            width: "150px",
            cell: (row) => (
                <div className="d-flex my-2">
                    <img
                        className="imageTable_rounded"
                        src={row.learner_profile_img}
                        alt="profile"
                        style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "50%" }}
                    />
                </div>
            ),
        },
        {
            name: "Name",
            selector: (row) => row.learner_name,
            sortable: true,
            width: "250px",
        },
        {
            name: "Email",
            selector: (row) => row.learner_email,
            sortable: true,
            width: "300px",
        },
        {
            name: "Age",
            selector: (row) => row.learner_age,
            sortable: true,
            width: "150px",
        },
        {
            name: "Registered On",
            selector: (row) => row.created_at,
            sortable: true,
            width: "200px",
            cell: (row) => moment(row.created_at).format("YYYY-MM-DD HH:mm:ss"),
        },
    ];

    const title = `Learners of ${stateParams.user_name || "Parent"}`;

    return (
        <>
            <JqueryLoad />
            <Hdashboard />
            <header className="dashboard-toolbar d-lg-flex justify-content-between">
                <div className="align-items-center justify-content-between d-flex">
                    <div className="d-flex align-items-center">
                        <a className="menu-toggle align-items-center d-lg-none d-flex">
                            <i className="fa fa-bars" />
                        </a>
                        <a href="index.php" className="d-lg-none d-block brand-logo">
                            <img src="./assets/images/logo.png" alt="logo" />
                        </a>
                    </div>
                </div>
            </header>

            <section className="main_sec">
                <div className="mt-4 mx-5">
                    <div>
                        <span onClick={handleBack} style={{ cursor: "pointer" }}>
                            <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.86172 2.225L8.37839 0.75L0.136719 9L8.38672 17.25L9.86172 15.775L3.08672 9L9.86172 2.225Z" fill="#131313" />
                            </svg>
                            <span className="ms-2">Back</span>
                        </span>
                    </div>
                    <p className="fs-4 fw-500 text-center mb-5">{title}</p>

                    <div className="mt-4">
                        {data && data.length > 0 ? (
                            <DataTable
                                columns={columns}
                                data={data}
                                pagination
                                paginationPerPage={paginationOption}
                                onChangeRowsPerPage={handlePaginationChange}
                                paginationRowsPerPageOptions={paginationOptions}
                                customStyles={customStyles}
                            />
                        ) : (
                            <p className="mt-5 text-center text-purple fw-500 fs-3 mt-5">No data Found</p>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
}
